<template>
    <div class="job-post pointer" @click="goHiredPage">
        <div class="p-3 shadow-sm border bg-white my-3 projects-lists" v-if="status == 'In Progress' || status == 'Closed'">
            <div class="row">
                <div class="col-6">
                    <div class="kova-circle">{{ title }}</div>
                    <p class="mt-2 font-weight-bolder text-left ml-2">{{ status }}</p>
                </div>
                <div class="col-6">
                    <div class="row justify-content-end pr-2">
                        <span class="id text-white">{{ projectBudget }}</span>
                        <!-- <a-icon class="ctrl-ellipsis font-weight-bolder" :rotate="90" type="ellipsis" /> -->
                    </div>
                </div>
            </div>
            <div class="">
                <h4 class="font-weight-bolder mx-1 text-left">{{ text }}</h4>
            </div>
        </div>
        <div class="p-3 shadow-sm border my-3 projects-lists kova-bg" v-if="status == 'On-going'">
            <div class="row">
                <div class="col-6">
                    <div class="kova-circle" style="border: solid 2px #fff;">{{ title }}</div>
                    <p class="mt-2 font-weight-bolder text-left ml-2 text-white">{{ status }}</p>
                </div>
                <div class="col-6">
                    <div class="row justify-content-end pr-2">
                        <span class="id text-white">{{ projectBudget }}</span>
                        <!-- <a-icon class="ctrl-ellipsis font-weight-bolder text-white" :rotate="90" type="ellipsis" /> -->
                    </div>
                </div>
            </div>
            <div class="">
                <h4 class="font-weight-bolder mx-1 text-left text-white">{{ text }}</h4>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: "job-post",
  props: {
    project: Object,
  },
  computed: {
    status() {
      const status = this.project.Status;
      return status == 3 ? 'On-going' : status == 1 ? 'In Progress' : 'Closed'
    },
    projectBudget() {
      const { StartBudget, EndBudget, Budget, Currency } = this.project
      if(StartBudget && EndBudget) return `${Currency}${this.formatAmount(StartBudget)} - ${Currency}${this.formatAmount(EndBudget)}`;
      return `${Currency}${this.formatAmount(Budget) || 0}`;
    },
    title() {
      return this.project.Title.slice(0, 2);
    },
    text() {
      return this.project.Title;
    }
  },
  data(){
    return {

    }
  },
  methods: {
    goHiredPage(){
      const status = this.project.Status;
      if(status !== 3) return this.$router.push(`/job-details?projectId=${this.project.ID}`)
      this.$router.push('hired')
    }
  }
}

</script>

<style scoped>
.projects-container{
    height: 530px;
    overflow-y: scroll;
}
.add-rounded{
    border-radius: 10px;
}

.kova-circle{
    height: 80px;
    width: 80px;
    border-radius: 50%;
    background-color: #20409A;
    color: #fff;
    font-size: 25px;
    font-weight: bolder;
    line-height: 80px;
}
.id{
    width: 100px;
    height: 20px;
    background-color: #4BB38E;
    border-radius: 5px;
}
.ctrl-ellipsis{
    font-size: 20px;
    color: #4BB38E;
}
.projects-lists{
    width: 260px;
}

/* total width */


/* set button(top and bottom of the scrollbar) */
.scrollbar::-webkit-scrollbar-button {display:none}

@media screen and (min-width: 992px) and (max-width: 1325px){
  .projects-lists{
        width: 300px;
    }  
}

@media screen and (min-width: 992px) and (max-width: 1200px){
    .employer-name{
        font-size: 18px;
    } 
    .img-height{
        width: 70px;
        height: 70px;
    }
    .projects-lists{
        width: 260px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px){
   
}

@media screen and (max-width: 767px){
    
}
</style>